import { Injectable } from "@angular/core";
import { PAGE_FIX_FIXABLE_TYPES } from "../../constants/page-fix-fixable-types";
import { PageFixModel } from "@client/app/services/api/pagefix-repo/page-fix-model";

@Injectable({
  providedIn: "root",
})

export class PageFixListService {
    getError (pageFix: PageFixModel): string[] {
        let selectorQueries = pageFix.selector.match(/;(.*)/)?.[1] ?? '';
        let fixableType = pageFix.normalizeFixableType();
        if (PAGE_FIX_FIXABLE_TYPES.custom === fixableType || PAGE_FIX_FIXABLE_TYPES.misspelling === fixableType) {
            return [selectorQueries];
        } else if (PAGE_FIX_FIXABLE_TYPES.accessibility_check === fixableType) {
            return JSON.parse(selectorQueries);
        } else {
            return JSON.parse(selectorQueries).map(function (selector) {
                let res = selector.match(/.*="(.*)"]/);
                if (res) {
                    return res[1];
                }
                return selector;
            });
        }
    }
}